module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/digitalCamouflageSummer/DIGITAL_CAMOUFLAGE_SUMMER_uk.ccd7d2cc.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/digitalCamouflageSummer/DIGITAL_CAMOUFLAGE_SUMMER_uk.png
// module id = 1236
// module chunks = 16